import React, { useEffect, useState } from "react"
import {
  Box,
  Container,
  Text,
  Heading,
  Grid,
  Input,
  Button,
  Flex,
  Label,
  Select,
} from "@theme-ui/components"
import { Textarea, Checkbox } from "theme-ui"
import { InboundLink } from "../link"
import { useGoogleReCaptcha } from "react-google-recaptcha-v3"
import { BsChevronRight } from "react-icons/bs"
import { i18nContext } from "../../context/i18nContext"
import { m } from "framer-motion"

const ApplicationForm = ({ block }) => {
  const {
    title,
    kicker,
    description,
    jobPosition,
    subtitle,
    privacyPolicyDescription,
    contactPage = true,
  } = block
  const { executeRecaptcha } = useGoogleReCaptcha()
  const isBrowser = typeof window !== "undefined"
  const [jobs, setJobs] = useState([])

  const [formData, setFormData] = useState({
    nome: "",
    cognome: "",
    indirizzo: "",
    CAP: "",
    citta: "",
    provincia: "",
    dataNascita: "",
    titoloStudio: "",
    voto: "",
    email: "",
    telefono: "",
    messaggio: "",
    motivi: "",
    job: "",
    accordoPrivacyCookies: false,
    accordoNewsLetter: false,
    urlPagina: isBrowser && window.location.href,
  })

  const [selectedCV, setSelectedCV] = useState([])
  const [selectedCover, setSelectedCover] = useState([])

  const [loading, setLoading] = useState(null)
  const [success, setSuccess] = useState(null)

  useEffect(() => {
    const jobElements = document.querySelectorAll("div[data-job]")
    let tmp = []
    jobElements.forEach(element => {
      tmp.push(element.getAttribute("data-job"))
    })
    setJobs(tmp)
  }, [])
  const onFileChange = e => {
    var filesArr = Array.prototype.slice.call(e.target.files)

    setSelectedCV([...selectedCV, ...filesArr])
  }

  const removeFile = f => {
    setSelectedCV(selectedCV.filter(x => x !== f))
  }

  const onFileChangeCover = e => {
    var filesArr = Array.prototype.slice.call(e.target.files)

    setSelectedCover([...selectedCover, ...filesArr])
  }

  const removeFileCover = f => {
    setSelectedCover(selectedCover.filter(x => x !== f))
  }

  const sendMail = async event => {
    event.preventDefault()
    setLoading(true)

    const result = await executeRecaptcha("dynamicAction")
    const data = { ...formData, cv: selectedCV, coverLetter: selectedCover }
    // console.log("data", data)

    if (result)
      new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(selectedCV[0])
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      }).then(file => {
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(selectedCV[0])
          reader.onload = () => resolve(reader.result)
          reader.onerror = error => reject(error)
        })
          .then(file2 => {
            fetch("/.netlify/functions/sendApplicationMail", {
              body: JSON.stringify({
                ...data,
                cv: file,
                coverLetter: file2,
              }),
              headers: {
                "content-type": "application/json",
              },
              method: "post",
            })
              .then(response => {
                if (response.status === 404) {
                  setLoading(false)
                  setSuccess(false)
                } else {
                  setSuccess(true)
                  setLoading(false)

                  if (
                    typeof window !== "undefined" &&
                    window.gtag !== undefined
                  ) {
                    window.gtag("event", "Submit", {
                      event_category: "Form",
                      event_label: "Application",
                    })
                  }
                }
              })
              .catch(error => {
                setLoading(false)
                setSuccess(false)
              })
          })
          .catch(error => {
            setLoading(false)
            setSuccess(false)
          })
      })
    else {
      setLoading(false)
      setSuccess(false)
    }
  }

  return (
    <i18nContext.Consumer>
      {t => (
        <Box sx={{ py: [4, 4], backgroundColor: "primary" }}>
          <Container name="contactForm">
            <Box>
              <Flex
                sx={{
                  justifyContent: "space-between",
                  flexDirection: ["column", "column", "row"],
                }}
              >
                <Box
                  sx={{
                    maxWidth: "559px",
                  }}
                >
                  <Heading
                    as="h2"
                    variant="h1"
                    sx={{
                      my: [4],
                      color: "light",
                      fontSize: [6, 8],
                      fontWeight: "body",
                      letterSpacing: "-.5px",
                      lineHeight: "1.12",
                    }}
                  >
                    {title}
                  </Heading>
                  <Heading
                    as="h3"
                    variant="h3"
                    sx={{
                      color: "light",
                      fontWeight: 300,
                      my: [0, 4],
                    }}
                  >
                    {kicker}
                  </Heading>
                  <Heading
                    as="h3"
                    variant="h3"
                    sx={{
                      color: "light",
                      fontWeight: 300,
                      my: [0, 4],
                    }}
                  >
                    {subtitle}
                  </Heading>
                  <Text
                    as="div"
                    variant="sectionTitle"
                    sx={{
                      my: [0, 4],
                      color: "light",
                      fontSize: [4],
                      fontWeight: 300,
                      letterSpacing: "-.5px",
                      lineHeight: "1.12",
                      em: {
                        fontStyle: "normal",
                        color: "light",
                      },
                    }}
                    dangerouslySetInnerHTML={{ __html: description }}
                  />
                </Box>
                <Box
                  as="form"
                  onSubmit={sendMail}
                  name="send-application"
                  sx={{ backgroundColor: "primary" }}
                >
                  <Container sx={{ padding: [0, 0, 4] }}>
                    <Grid
                      sx={{
                        flexWrap: "wrap",
                        flexDirection: "column",
                      }}
                      gap={[0, 0, 0, 0]}
                    >
                      <Flex sx={{ flexWrap: "wrap" }}>
                        <Box
                          sx={{
                            pr: [0, 1, 1, 1],
                            pb: [3, 3, 3, 3],
                            width: ["100%", "50%"],
                          }}
                        >
                          <Label>{t.formInputTexts.firstName + "*"}</Label>
                          <Input
                            onChange={e =>
                              setFormData(prevState => ({
                                ...prevState,
                                nome: e.target.value,
                              }))
                            }
                            name={t.formInputTexts.firstName}
                            variant="inputs.light"
                            required
                          />
                        </Box>
                        <Box
                          sx={{
                            pl: [0, 1, 1, 1],
                            pb: [3, 3, 3, 3],
                            width: ["100%", "50%"],
                          }}
                        >
                          <Label>{t.formInputTexts.lastName + "*"}</Label>
                          <Input
                            onChange={e =>
                              setFormData(prevState => ({
                                ...prevState,
                                cognome: e.target.value,
                              }))
                            }
                            name={t.formInputTexts.lastName}
                            variant="inputs.light"
                            required
                          />
                        </Box>
                      </Flex>
                      <Flex sx={{ flexWrap: "wrap" }}>
                        <Box
                          sx={{
                            pr: [0, 1, 1, 1],
                            pb: [3, 3, 3, 3],
                            width: ["100%", "50%"],
                          }}
                        >
                          <Label>{t.formInputTexts.birthday + "*"}</Label>
                          <Input
                            onChange={e =>
                              setFormData(prevState => ({
                                ...prevState,
                                dataNascita: e.target.value,
                              }))
                            }
                            name={t.formInputTexts.birthday}
                            variant="inputs.light"
                            sx={{
                              fontFamily: "body",
                              colorScheme: "light",
                              "&::-webkit-calendar-picker-indicator": {
                                cursor: "pointer",
                                opacity: 1,
                                filter: "invert(1)",
                              },
                              "&::-webkit-calendar-picker-indicator:hover": {
                                opacity: 1,
                              },
                              "&:invalid::-webkit-datetime-edit": {
                                color: "lighten",
                              },
                            }}
                            type="date"
                            required
                          />
                        </Box>
                        <Box
                          sx={{
                            pl: [0, 1, 1, 1],
                            pb: [3, 3, 3, 3],
                            width: ["100%", "50%"],
                          }}
                        >
                          <Label>{t.formInputTexts.phone + "*"}</Label>
                          <Input
                            onChange={e =>
                              setFormData(prevState => ({
                                ...prevState,
                                telefono: e.target.value,
                              }))
                            }
                            name="telefono"
                            type="text"
                            variant="inputs.light"
                            required
                          />
                        </Box>
                      </Flex>
                      <Flex sx={{ flexWrap: "wrap" }}>
                        <Box
                          sx={{
                            pb: [3, 3, 3, 3],
                            width: ["100%", "100%"],
                          }}
                        >
                          <Label>{t.formInputTexts.email + "*"}</Label>
                          <Input
                            onChange={e =>
                              setFormData(prevState => ({
                                ...prevState,
                                email: e.target.value,
                              }))
                            }
                            name={t.formInputTexts.email}
                            variant="inputs.light"
                            type="email"
                            required
                          />
                        </Box>
                        <Box
                          sx={{
                            pb: [3, 3, 3, 3],
                            width: ["100%", "100%"],
                          }}
                        >
                          <Label>{t.formInputTexts.address + "*"}</Label>
                          <Input
                            onChange={e =>
                              setFormData(prevState => ({
                                ...prevState,
                                indirizzo: e.target.value,
                              }))
                            }
                            name={t.formInputTexts.address}
                            variant="inputs.light"
                            type="text"
                            required
                          />
                        </Box>
                        <Box
                          sx={{
                            pr: [0, 1, 1, 1],
                            pb: [3, 3, 3, 3],
                            width: ["100%", "25%"],
                          }}
                        >
                          <Label>{t.formInputTexts.zipCode + "*"}</Label>
                          <Input
                            onChange={e =>
                              setFormData(prevState => ({
                                ...prevState,
                                CAP: e.target.value,
                              }))
                            }
                            name={t.formInputTexts.zipCode}
                            type="text"
                            variant="inputs.light"
                            required
                          />
                        </Box>
                        <Box
                          sx={{
                            pr: [0, 1, 1, 1],
                            pl: [0, 1, 1, 1],
                            pb: [3, 3, 3, 3],
                            width: ["100%", "45%"],
                          }}
                        >
                          <Label>{t.formInputTexts.city + "*"}</Label>
                          <Input
                            onChange={e =>
                              setFormData(prevState => ({
                                ...prevState,
                                citta: e.target.value,
                              }))
                            }
                            name="city"
                            variant="inputs.light"
                            type="text"
                            required
                          />
                        </Box>
                        <Box
                          sx={{
                            pl: [0, 1, 1, 1],
                            pb: [3, 3, 3, 3],
                            width: ["100%", "30%"],
                          }}
                        >
                          <Label>{t.formInputTexts.province + "*"}</Label>
                          <Input
                            onChange={e =>
                              setFormData(prevState => ({
                                ...prevState,
                                provincia: e.target.value,
                              }))
                            }
                            name={t.formInputTexts.province}
                            variant="inputs.light"
                            type="text"
                            maxLength={2}
                            required
                          />
                        </Box>
                      </Flex>
                      <Flex sx={{ flexWrap: "wrap" }}>
                        <Box
                          sx={{
                            pb: [3, 3, 3, 3],
                            width: ["100%", "100%"],
                          }}
                        >
                          <Label>{t.formInputTexts.role + "*"}</Label>
                          <Select
                            onChange={e =>
                              setFormData(prevState => ({
                                ...prevState,
                                job: e.target.value,
                              }))
                            }
                            variant="inputs.light"
                            sx={{
                              color: formData.job === "" && "light",
                              opacity: formData.job === "" && 0.6,
                              'option[value=""][disabled][selected]': {
                                color: "lighten",
                              },
                            }}
                            name={t.formInputTexts.jobPosition}
                            type="text"
                            required
                          >
                            <option value="" selected default disabled></option>
                            {jobs.map(job => (
                              <option value={job}>{job}</option>
                            ))}
                          </Select>
                        </Box>
                      </Flex>
                      <Box
                        sx={{
                          p: [2],
                          mb: [3, 3, 3, 3],
                          display: "grid",
                          overflow: "hidden",
                          gridTemplateColumns: ["1fr", "1fr 1fr"],
                          gap: [16, 0],
                          justifyContent: "space-between",
                          alignItems: "center",
                          fontSize: [3, 3, 4, 4],
                          fontFamily: "roc",
                          borderRadius: 0,
                          color: "light",
                          border: "none",
                          borderBottom: "1px solid",
                          borderColor: "light",
                          "&::placeholder": {
                            color: "light",
                            opacity: 0.6,
                          },
                          'input[type="file"]': {
                            display: "none",
                          },
                        }}
                      >
                        <Box>
                          {selectedCV && selectedCV.length ? (
                            selectedCV.map(x => (
                              <Box
                                className="file-preview"
                                sx={{
                                  fontFamily: "body",
                                  display: "flex",
                                }}
                              >
                                {x.name}
                                <Box
                                  sx={{
                                    ml: [2],
                                    cursor: "pointer",
                                  }}
                                  onClick={() => removeFile(x)}
                                >
                                  X
                                </Box>
                              </Box>
                            ))
                          ) : (
                            <Box
                              sx={{
                                opacity: 0.6,
                                fontWeight: "400",
                                fontFamily: "body",
                                fontSize: [2],
                              }}
                            >
                              {t.cv}*
                            </Box>
                          )}
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Box
                            as="label"
                            sx={{
                              fontSize: [3, 3, 4],
                              p: [2],
                              px: [3],
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              backgroundColor: "light",
                              color: "primary",
                              cursor: "pointer",
                              fontSize: [2, 3],
                              svg: {
                                fill: "primary",
                                transition: "all .2s ease",
                                maxWidth: "25px",
                                maxHeight: "25px",
                              },
                            }}
                          >
                            <input
                              type="file"
                              onChange={onFileChange}
                              accept=".doc,.docx,.pdf,.txt"
                              onClick={event => {
                                event.target.value = null
                              }}
                              required
                            />
                            <Box sx={{ fontFamily: "body" }}>
                              {t.formInputTexts.fileSelect}
                            </Box>
                            <Box
                              className="hoverSvg"
                              sx={{
                                ml: [4],
                                maxWidth: "35px",
                                maxHeight: "35px",
                                width: "35px",
                                height: "35px",
                                transition: "all .2s ease",
                                maxWidth: ["30%", "30%", "30%", "30%"],
                                border: "1px solid",
                                borderRadius: "100%",
                                borderColor: "primary",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <BsChevronRight />
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                      <Box
                        sx={{
                          p: [2],
                          mb: [3, 3, 3, 3],
                          display: "grid",
                          overflow: "hidden",
                          gridTemplateColumns: ["1fr", "1fr 1fr"],
                          gap: [16, 0],
                          justifyContent: "space-between",
                          alignItems: "center",
                          fontSize: [3, 3, 4, 4],
                          fontFamily: "roc",
                          borderRadius: 0,
                          color: "light",
                          border: "none",
                          borderBottom: "1px solid",
                          borderColor: "light",
                          "&::placeholder": {
                            color: "light",
                            opacity: 0.6,
                          },
                          'input[type="file"]': {
                            display: "none",
                          },
                        }}
                      >
                        <Box>
                          {selectedCover && selectedCover.length ? (
                            selectedCover.map(x => (
                              <Box
                                className="file-preview"
                                sx={{
                                  fontFamily: "body",
                                  display: "flex",
                                }}
                              >
                                {x.name}
                                <Box
                                  sx={{
                                    ml: [2],
                                    cursor: "pointer",
                                  }}
                                  onClick={() => removeFileCover(x)}
                                >
                                  X
                                </Box>
                              </Box>
                            ))
                          ) : (
                            <Box
                              sx={{
                                opacity: 0.6,
                                fontWeight: "400",
                                fontFamily: "body",
                                fontSize: [2],
                              }}
                            >
                              {t.cover}
                            </Box>
                          )}
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <Box
                            as="label"
                            sx={{
                              fontSize: [3, 3, 4],
                              p: [2],
                              px: [3],
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              backgroundColor: "light",
                              color: "primary",
                              fontSize: [2, 3],
                              cursor: "pointer",
                              svg: {
                                fill: "primary",
                                transition: "all .2s ease",
                                maxWidth: "25px",
                                maxHeight: "25px",
                              },
                            }}
                          >
                            <input
                              type="file"
                              onChange={onFileChangeCover}
                              accept=".doc,.docx,.pdf,.txt"
                              onClick={event => {
                                event.target.value = null
                              }}
                            />
                            <Box sx={{ fontFamily: "body" }}>
                              {t.formInputTexts.fileSelect}
                            </Box>
                            <Box
                              className="hoverSvg"
                              sx={{
                                ml: [4],
                                maxWidth: "35px",
                                maxHeight: "35px",
                                width: "35px",
                                height: "35px",
                                transition: "all .2s ease",
                                maxWidth: ["30%", "30%", "30%", "30%"],
                                border: "1px solid",
                                borderRadius: "100%",
                                borderColor: "primary",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <BsChevronRight />
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                      <Label>{t.formInputTexts.message}</Label>
                      <Textarea
                        sx={{
                          fontFamily: "body",
                          fontSize: [2],
                        }}
                        onChange={e =>
                          setFormData(prevState => ({
                            ...prevState,
                            messaggio: e.target.value,
                          }))
                        }
                        name="messaggio"
                        type="textarea"
                        variant="inputs.light"
                      />
                      <LabeledCheckbox
                        checkedCheckbox={e => {
                          setFormData(prevState => ({
                            ...prevState,
                            accordoPrivacyCookies: e,
                          }))
                        }}
                        required={true}
                      >
                        <Box
                          dangerouslySetInnerHTML={{
                            __html: privacyPolicyDescription,
                          }}
                        />
                      </LabeledCheckbox>
                      <Button
                        type="submit"
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          mt: [3, 3, 3, 3],
                          px: [4],
                          opacity: formData.accordoPrivacyCookies ? 1 : 0.7,
                          borderRadius: "20px 0 20px 0",
                          backgroundColor: "light",
                          color: "primary",
                          "&:hover": {
                            color: "light",
                            svg: {
                              circle: {
                                stroke: "primary",
                                strokeWidth: "2px",
                              },
                              use: {
                                fill: "primary",
                              },
                              "g#Group": {
                                fill: "primary",
                              },
                            },
                          },
                        }}
                        disabled={loading}
                      >
                        {loading
                          ? "Caricamento..."
                          : t.formInputTexts.submitApplication}
                        <Box
                          className="hoverSvg"
                          sx={{
                            ml: [4],
                            maxWidth: "35px",
                            maxHeight: "35px",
                            width: "35px",
                            height: "35px",
                            transition: "all .2s ease",
                            maxWidth: ["30%", "30%", "30%", "30%"],
                            border: "1px solid",
                            borderRadius: "100%",
                            borderColor: "primary",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <BsChevronRight />
                        </Box>
                      </Button>
                      {success === true ? (
                        <Flex sx={{ maxWidth: "600px" }}>
                          <Heading sx={{ my: [4], color: "light" }} as="h5">
                            Candidatura inviata!
                          </Heading>
                        </Flex>
                      ) : (
                        success === false && (
                          <Flex sx={{ maxWidth: "600px" }}>
                            <Heading sx={{ my: [4], color: "dark" }} as="h5">
                              Qualcosa è andato storto
                            </Heading>
                          </Flex>
                        )
                      )}
                    </Grid>
                  </Container>
                </Box>
              </Flex>
            </Box>
          </Container>
        </Box>
      )}
    </i18nContext.Consumer>
  )
}

const LabeledCheckbox = ({
  children,
  checkedCheckbox,
  defaultChecked,
  ...props
}) => {
  const [checked, setChecked] = useState(defaultChecked)
  return (
    <Label
      sx={{
        display: "flex",
        alignItems: "center",
        color: "light",
        mt: [3, 3, 3, 3],
        svg: {
          fill: "light",
        },
      }}
    >
      <Checkbox
        sx={{ color: "light" }}
        checked={checked}
        onChange={() => {
          checkedCheckbox(!checked)
          setChecked(!checked)
        }}
        required={true}
      />
      {children}
    </Label>
  )
}

export default ApplicationForm
